export const language = {
  en: {
    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'resetting': 'resetting',
    'query': 'query',
    'Please Entry': 'Please Entry',
    'Please select': 'Please select',
    'View': 'View',
    'supplier performance': 'supplier performance',
    'Supplier Name': 'Supplier Name',
    'Cooperative category': 'Cooperative category',
    'Life cycle': 'Life cycle',
    'Company Attributes': 'Company Attributes',
    'Company Type': 'Company Type',
    'Performance Level': 'Performance Level',
    'Performance Evaluation': 'Performance Evaluation',
    'Company Name': 'Company Name',
    'Unified Social Credit Code': 'Unified Tax ID',
    'Company Country': 'Company Country',
    'China': 'China',
    'Thailand': 'Thailand',
    'Australia': 'Australia',
    'United States': 'United States',
    'United Kingdom': 'United Kingdom',
    'France': 'France',
    'Company Address': 'Company Address',
    'Province': 'Province',
    'City': 'City',
    'District': 'District',
    'Bank Account': 'Bank Account',
    'Landline Number': 'Landline Number',
    'Tel Number': 'Tel Number',
    'Email': 'Email',
    'Whether Production Base': 'Whether Production Base',
    'Yes': 'Yes',
    'No': 'No',
    'Category': 'Category',
    'Contact Name ': 'Contact Name ',
    'Please Entry Contact Name ': 'Please Entry Contact Name ',
    'Contact Information': 'Contact Information',
    'Please Entry Contact Information': 'Please Entry Contact Information',
    'Country': 'Country',
    'Detail Address': 'Detail Address',
    'Please Entry Detail Address': 'Please Entry Detail Address',
    'Post Code': 'Post Code',
    'Please Entry Post Code': 'Please Entry Post Code',
    'Remarks': 'Remarks',
    'Business License': 'Business License',
    'Legal Person Certificate': 'Legal Person Certificate',
    'Company Certificate': 'Company Certificate',
    'Upload Files': 'Upload Files',
    'Upload': 'Upload',
    'Support Extension': 'Support Extension',
    'Certification': 'Certification',
    'Current Performance': 'Current Performance',
    'Evaluation time': 'Evaluation time',
    'Assessor': 'Assessor',
    'Serial Number': 'Serial Number',
    'operate': 'operate',
    'data': 'data',
    'whole': 'whole',
    'Basic information': 'Basic information',
    'Address information': 'Address information',
    'Telephone': 'Telephone',
    'Address': 'Address',
    'Postal Code': 'Postal Code',
    'Qualification information': 'Qualification information',
    'Qualification materials': 'Qualification materials',
    'Performance management': 'Performance management',
    'Back': 'Back',
    'Pending cooperation': 'Pending cooperation',
    'Negotiating': 'Negotiating',
    'In Cooperation': 'In Cooperation',
    'In Retreat': 'In Retreat',
    'End the Cooperation': 'End the Cooperation',
    'CP group': 'CP group',
    'Non CP group': 'Non CP group',
    'group': 'group',
    'company': 'company',
    'store': 'store',
    'warehouse': 'warehouse',
  },
  zh: {
    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'resetting': '重置',
    'query': '查询',
    'Please Entry': '请输入',
    'Please select': '请选择',
    'View': '查看',
    'supplier performance': '供应商绩效',
    'Supplier Name': '供应商名称',
    'Cooperative category': '合作品类',
    'Life cycle': '生命周期',
    'Company Attributes': '公司属性',
    'Company Type': '公司类型',
    'Performance Level': '绩效等级',
    'Performance Evaluation': '绩效评定',
    'Company Name': '公司名称',
    'Unified Social Credit Code': '统一社会信用代码',
    'Company Country': '公司所在国家',
    'China': '中国',
    'Thailand': '泰国',
    'Australia': '澳大利亚',
    'United States': '美国',
    'United Kingdom': '英国',
    'France': '法国',
    'Company Address': '公司地址',
    'Province': '省',
    'City': '市',
    'District': '区',
    'Bank Account': '银行账号',
    'Landline Number': '座机号',
    'Tel Number': '手机号',
    'Email': '邮箱',
    'Whether Production Base': '是否基地',
    'Yes': '是',
    'No': '否',
    'Category': '经营品类',
    'Contact Name ': '联系人姓名',
    'Please Entry Contact Name ': '请输入联系人姓名',
    'Contact Information': '联系方式',
    'Please Entry Contact Information': '请输入联系方式',
    'Country': '国家',
    'Detail Address': '详细地址',
    'Please Entry Detail Address': '请输入详细地址',
    'Post Code': '邮政编码',
    'Please Entry Post Code': '请输入邮政编码',
    'Remarks': '备注',
    'Business License': '营业执照',
    'Legal Person Certificate': '法人证件',
    'Company Certificate': '公司资质',
    'Upload Files': '上传文件',
    'Upload': '上传',
    'Support Extension': '支持扩展名',
    'Certification': '资质',
    'Current Performance': '当前绩效',
    'Evaluation time': '评定时间',
    'Assessor': '评定人',
    'Serial Number': '序号',
    'operate': '操作',
    'data': '数据',
    'whole': '全部',
    'Basic information': '基本信息',
    'Address information': '地址信息',
    'Telephone': '联系电话',
    'Address': '地址',
    'Postal Code': '邮编',
    'Qualification information': '资质信息',
    'Qualification materials': '资质材料',
    'Performance management': '绩效管理',
    'Back': '返回',
    'Pending cooperation': '待合作',
    'Negotiating': '洽谈中',
    'In Cooperation': '合作中',
    'In Retreat': '清退中',
    'End the Cooperation': '合作终止',
    'CP group': '正大',
    'Non CP group': '非正大',
    'group': '集团',
    'company': '公司',
    'store': '门店',
    'warehouse': '大仓',
  }
};
